export const secondsConverter = (seconds) => {
    return (`${Math.floor(seconds/60)}min`)
}